import { PLOT_TYPE } from "./indicatorTypes";
import { plotShift } from "./indicatorSettings";

const MS_PER_SECOND = 1000;

const drawnPlots = (definition) => definition.plots.filter((plot) => plot.type !== PLOT_TYPE.FILL);

/**
 * @param {object} definition
 * @returns {string[]} keys of the plots that have values, in the order of readIndicatorValues
 */
export const drawnPlotKeys = (definition) => drawnPlots(definition).map((plot) => plot.key);

/**
 * Values of an indicator for comparing with TradingView (`exportData` of
 * the old chart) or PO: one row per bar with the bar open time in UTC
 * seconds and a value per drawn plot in the order of drawnPlotKeys (the
 * `plots` of the definition without backgrounds); null where there is no value.
 * A shifted plot gives at a bar the value it draws there.
 *
 * @param {object} instance - indicatorInstance
 * @param {object[]} storeBars - the stored bars (engine.data.store.bars), oldest first
 * @returns {Array<{ time: number, values: Array<number|null> }>}
 */
export const readIndicatorValues = (instance, storeBars) => {
  const { definition, series, inputs } = instance;
  const plots = drawnPlots(definition);
  const shifts = plots.map((plot) => plotShift(plot, inputs));

  return storeBars.map((bar, index) => ({
    time: Math.round(bar.time / MS_PER_SECOND),
    values: plots.map((plot, plotIndex) => {
      const value = series[plot.key][index - shifts[plotIndex]];

      return Number.isFinite(value) ? value : null;
    }),
  }));
};
